import React, { FC, useState } from 'react';

import { Badge, Box, Stack, Text } from '@mantine/core';

import { Component } from 'models';

import { ComponentDatasheet } from 'components/component-datasheet/components/ComponentDatasheet.Team';
import { ComponentDatasheetActions } from 'components/component-datasheet/components/ComponentDatasheetActions.Team';
import { CurrentComponentContext } from 'components/component-datasheet/hooks/use-component-context';
import { useDatasheetMeta } from 'components/component-datasheet/hooks/use-datasheet-meta';
import { ComponentForm } from 'components/component-form/ComponentForm';
import { Page } from 'components/page/Page';
import { useCurrentTeams } from 'hooks/use-current-teams';

import cx from './ComponentDetail.Team.module.scss';

interface Props {
    component: Component;
}

const ComponentDetail: FC<Props> = ({ component }) => {
    const { subtitle } = useDatasheetMeta(component);

    const teams = useCurrentTeams();
    const componentTeam = teams.find((team) => team.id === component.team);

    if (!componentTeam) return null;

    return (
        <Page showBackground title={component.name}>
            <Page.Content
                title={component.name}
                subtitle={subtitle}
                afterTitle={
                    <Stack gap={4}>
                        <Badge size="sm" color="orange" variant="light">
                            Private
                        </Badge>
                        <Text size="xs" c="dimmed">
                            Everyone in team{' '}
                            <Text span inherit fw={500}>
                                {componentTeam?.name}
                            </Text>{' '}
                            can view and modify
                        </Text>
                    </Stack>
                }
                rightSection={<ComponentDatasheetActions />}
            >
                <Box className={cx.root}>
                    <ComponentDatasheet component={component} />
                </Box>
            </Page.Content>
        </Page>
    );
};

const WrappedComponentDetail: FC<Props> = (props) => {
    const [currentComponent, setCurrentComponent] = useState<Component>(props.component);

    return (
        <CurrentComponentContext.Provider
            value={{
                component: currentComponent,
                setComponent: setCurrentComponent,
            }}
        >
            <ComponentForm initialValues={props.component}>
                <ComponentDetail {...props} />
            </ComponentForm>
        </CurrentComponentContext.Provider>
    );
};

export { WrappedComponentDetail as ComponentDetail };
